// extracted by mini-css-extract-plugin
export var form = "_5j-0";